import {
  PerformersCard as BasePerformersCard,
  PerformersCardProps as BasePerformersCardProps,
} from '@features/campaigns/components/RealTimeOptimization/Performers/PerformersCard';
import { CpgDimension, CpgReport } from '../../../api/schema';
import { AIInsights } from '@features/ai-insights';

type LiftOption = BasePerformersCardProps<
  PerformersCardProps['reports'][number],
  PerformersCardProps['dimensions'][number],
  'sales'
>['liftOptions'][number];

const salesLiftOption = {
  value: 'sales',
  name: 'Sales',
  chartLabel: 'Incremental Sales Lift',
} as const satisfies LiftOption;

type MinimalCpgDimension = Pick<
  CpgDimension,
  | 'incrementalSalesLift'
  | 'dimensionName'
  | 'dimensionValue'
  | 'statisticallySignificant'
>;
type MinimalCpgReport = Pick<
  CpgReport,
  'reportDate' | 'incrementalSalesLift'
> & { dimensions: MinimalCpgDimension[] };

export type PerformersCardProps = {
  reports: MinimalCpgReport[];
  dimensions: MinimalCpgDimension[];
  aiInsights: AIInsights | null;
};

export const PerformersCard = (props: PerformersCardProps) => {
  return (
    <BasePerformersCard
      reports={props.reports}
      reportDates={props.reports.map(report => report.reportDate)}
      currentSubdimensions={props.dimensions.map(d => ({
        ...d,
        value: d.dimensionValue,
        name: d.dimensionName,
      }))}
      getValueByLiftType={{
        sales: subdimension => subdimension.incrementalSalesLift,
      }}
      getOverallValueByLiftType={{
        sales: report => report.incrementalSalesLift,
      }}
      getSubdimensionsFromReport={report =>
        report.dimensions.map(d => ({
          ...d,
          value: d.dimensionValue,
          name: d.dimensionName,
        }))
      }
      defaultLiftType="sales"
      liftOptions={[salesLiftOption]}
      aiInsights={props.aiInsights}
    />
  );
};
